import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as signalR from '@microsoft/signalr';
import { environment } from 'src/environments/environment';

export type CallMode = 'birthday' | 'talk';
export interface IncomingCallPayload {
  found: boolean;
  visitorId?: number;
  fullName?: string;
  phone: string;
  ext?: string;
   evt?: 'NOTIFY_IVR' | 'NOTIFY_ANSWER' | string;
  mode?: CallMode;
   callId?: string;
  digit?: string;
  action?: 'open_form_birthday' | 'operator_talk' | string | null;
  preview?: boolean;
}

@Injectable({ providedIn: 'root' })
export class CallHubService {
  private hub?: signalR.HubConnection;
  private currentExt?: string;

  incoming$ = new Subject<IncomingCallPayload>();

  private hubUrl(): string {
    const base = environment.apiUrl.replace(/\/+$/, '');
    return `${base}/hubs/call`;
  }

  async connect(ext: string): Promise<void> {
    if (this.hub) return;
    this.currentExt = ext;

    this.hub = new signalR.HubConnectionBuilder()
      .withUrl(this.hubUrl(), { withCredentials: true })
      .withAutomaticReconnect() // [0ms, 2s, 10s, 30s...]
      .build();

    this.hub.on('incomingCall', (payload: IncomingCallPayload) => {
  
      if (this.currentExt && payload?.ext && payload.ext !== this.currentExt) {
        console.warn('[CALL] payload for different ext, ignoring:', payload.ext, '!=', this.currentExt);
        return;
      }
      console.log('[CALL] incoming payload:', payload);
      this.incoming$.next(payload);
    });

    this.hub.onreconnecting(err => console.warn('[CALL] reconnecting...', err));
    this.hub.onreconnected(async id => {
      console.log('[CALL] reconnected, id:', id);
      try {
        if (this.currentExt) {
          await this.hub!.invoke('RegisterExtension', this.currentExt);
          console.log('[CALL] rejoined group ext:', this.currentExt);
        }
      } catch (e) {
        console.warn('[CALL] rejoin failed:', e);
      }
    });
    this.hub.onclose(err => console.warn('[CALL] closed', err));

    await this.hub.start();
    console.log('[CALL] hub started, registering ext:', ext);

    await this.hub.invoke('RegisterExtension', ext);
    console.log('[CALL] joined group ext:', ext);

    window.addEventListener('beforeunload', () => this.disconnect());
  }

  async disconnect(): Promise<void> {
    if (!this.hub) return;
    if (this.currentExt) {
      try { await this.hub.invoke('UnregisterExtension', this.currentExt); } catch { /* ignore */ }
    }
    await this.hub.stop();
    this.hub = undefined;
    this.currentExt = undefined;
  }
}
